/* eslint-disable camelcase */
import {
  createStore, combineReducers, applyMiddleware, compose,
} from 'redux';
import thunk from 'redux-thunk';
import { reducer as formReducer } from 'redux-form';

// helpers

// Reducers Imports
import { steps } from '../reducers/stepsReducer';
import {
  formConfig, companyDetails, dropdownLists, paymentDetails,
} from '../reducers/formConfigReducer';
// import { imports } from '../reducers/importsReducer';
// import { navigation } from '../reducers/navigationreducer';
// Action Creators


// eslint-disable-next-line no-underscore-dangle
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
const rootReducer = combineReducers({
  form: formReducer,
  steps,
  formConfig,
  companyDetails,
  dropdownLists,
  paymentDetails,
});
const store = createStore(
  rootReducer,
  {},
  composeEnhancers(applyMiddleware(thunk)),
);

export default store;
